import React, { useState } from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import Experience from "../../public/img/experience.png"
import ReviewMetrics from "../../public/img/review-metrics.png"
import SellerLocation from "../../public/img/seller-location.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import { SUPPORT_URL } from "../../utils/Constants"
import ModalIframe from "../../components/modalIframe/ModalIframe"
export default function AmazonCustomers() {
  const textColor = useColorModeValue("gray.500", "white")
  const [subscribeModalShow, setSubscribeModalShow] = useState(false)
  const [iframeUrl, setIframeUrl] = useState("")
  const [heading, setHeading] = useState("")
  const [height, setHeight] = useState("480px")

  const subscribeModalToggle = (url, heading, height) => {
    setIframeUrl(url)
    setHeading(heading)
    setHeight(height)
    setSubscribeModalShow(!subscribeModalShow)
  }
  function ButtonClick() {
    subscribeModalToggle(SUPPORT_URL, "Contact", "680px")
  }
  return (
    <>
      <Meta
        pageName={"TrackSellers | Amazon Customers"}
        hrefLink={"https://www.tracksellers.com/amazon-customers"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading mb="18px" className={styles.ReportHead} >
                Amazon Customers
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Know who you are buying from
              </Text>
              <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Amazon sellers come in all sizes and are all over the world. A seller’s reputation is as important as product reviews. Know rank, size, and location at a glance
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Experience}
                    alt="Experience"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Size of a seller is an indicator of experience and reliability
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Identify reliable sellers with proven track record for critical purchases
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Access reviews, order count and other metrics
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Check reputation and reviews of an Amazon seller
                    </Text>
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={ReviewMetrics}
                    alt="ReviewMetrics"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={SellerLocation}
                    alt="SellerLocation"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Know seller’s location and fulfillment method
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Find out if sellers are legitimate or not using their address, rank and shipping details
                    </Text>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="4rem" mb="2rem" textAlign="center" >
          <Link >
            <ButtonPrimary ButtonClick={ButtonClick} buttonName="Contact Us" />
          </Link>
        </Box>
      </Box>
      <ModalIframe
        show={subscribeModalShow}
        close={subscribeModalToggle}
        heading={heading}
        iframeUrl={iframeUrl}
        height={height}
      />
    </>
  )
}